import { Routes } from '@angular/router';
import { InternalLayoutComponent } from '../layouts';
import { AuthGuard } from '../../shared/auth/services';
import { PhotoListComponent } from './pages/photo-list';
import { SharedLayoutMainComponent } from '../shared/layouts/main';

export const photoRoutes: Routes = [
  {
    path: 'useraccount',
    component: InternalLayoutComponent,
    canActivate: [AuthGuard],
    data: { roles: [] },
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'photos',
        component: SharedLayoutMainComponent,
        children: [
          { path: '', component: PhotoListComponent, title: 'Photos' },
        ]
      },
    ]
  }
];
